export const THEME_PREFERENCE_KEY = 'spark.theme-preference';
export const THEME_MODES = ['system', 'light', 'dark'];

const isThemeMode = (mode) => THEME_MODES.includes(mode);

export function readThemePreference(getStorage = () => window.localStorage) {
  try {
    const mode = getStorage().getItem(THEME_PREFERENCE_KEY);
    return isThemeMode(mode) ? mode : 'system';
  } catch {
    return 'system';
  }
}

export function writeThemePreference(mode, getStorage = () => window.localStorage) {
  if (!isThemeMode(mode)) return;

  try {
    getStorage().setItem(THEME_PREFERENCE_KEY, mode);
  } catch {
    // Storage can be unavailable in private or restricted browsing contexts.
  }
}

export function resolveTheme(mode, systemPrefersDark) {
  if (mode === 'dark') return 'dark';
  if (mode === 'light') return 'light';
  return systemPrefersDark ? 'dark' : 'light';
}
